export const foo = () => (null)
